import React from "react";
import MaintenanceField from "../positionMaintenance/MaintenanceField";
import {Divider, Button} from "antd";

export class RightContent extends MaintenanceField {
    getUrl(type) {
        let id = this.props.match.params.id;
        switch (type) {
            case "preEdit":
                return "/cm-sites-media-consumer/system/activityField/preEdit";
            case "preDelete":
                return "/cm-sites-media-consumer/system/activityField/preDelete";
            case "getListDataById":
                return "/cm-sites-media-consumer/system/activityField/getByActivityTypeId";
            case "recoverToDefault":
                return "/cm-sites-media-consumer/system/activityField/recoverToDefaultFields";
            case "batchDelete":
                return "/cm-sites-media-consumer/system/activityField//batchDelete";
            case "saveAll":
                return '/cm-sites-media-consumer/system/activityField/saveAll?typeId=' + id;
            default:
                return "";
        }
    }

    searchHeight = 54; // 搜索区高度
    tableTopPadding = 20; //table顶部边距

    renderTop() {
        return (
            <div style={{
                fontSize: 16,
                color: "#222",
                height: 54,
                marginBottom: 20,
                lineHeight: "54px",
                borderBottom: "1px solid #ddd"
            }}><span style={{paddingLeft: 24}}>
                审核备注维护-{this.props.name}
            </span></div>
        )
    }

    renderBtn() {
        return (
            <div id={"mainteranceField"} style={{backgroundColor: "#fff"}}>
                <Divider/>
                <div style={{justifyContent: "center", display: "flex", alignItems: "center", paddingBottom: 15}}>
                    {/*<Button onClick={() => this.restoreData()}>恢复默认</Button>*/}
                    <Button onClick={() => this.saveAll()} type="primary">保存</Button>
                </div>
                <style>{`
                    #mainteranceField .ant-divider-horizontal{margin: 0px 0px 15px 0px !important;}
                    #mainteranceField button{margin: 0 10px;}
                `}</style>
            </div>
        )
    }
}